import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../configs/firebase";
import { PageHeader, Collapse, Card } from "antd";
import "../styles/admin.scss";
// const { Panel } = Collapse;

export default function Admin() {
  const [users, setUsers] = useState([]);
  // const [oldUsers, setOldUsers] = useState([]);
  // const [db2Users, setDb2Users] = useState([]);

  useEffect(() => {
    // get docs from surveys collection
    getDocs(collection(db, "surveys")).then((docs) => {
      docs.forEach((doc) => {
        setUsers((users) => [...users, doc.data()]);
      });
    });
  }, []);
  return (
    <div className="admin-panel">
      <PageHeader
        title="Admin"
        subTitle="Survey Management"
        style={{
          border: "1px solid rgb(235, 237, 240)",
        }}
      />
      <Card>
        <h1 style={{ color: "#000" }}>
          Total Number of Responses: {users && users.length}
        </h1>
        {/* <h5 style={{ color: "#000" }}>
          Number of Responses (new): {users && users.length}
        </h5>
        <h5 style={{ color: "#000" }}>
          Number of Responses (old): {oldUsers && oldUsers.length}
        </h5> */}

        <Collapse bordered={false} className="site-collapse-custom-collapse">
          {/* <Panel
            header="This is panel header 1"
            key="1"
            className="site-collapse-custom-panel"
          >
            <p>{"lol"}</p>
          </Panel>
           */}
          {/* {users &&
            users.map((user, idx) => {
              return (
                <Panel
                  header={`${user.name} - ${user.email}`}
                  key={idx}
                  className="site-collapse-custom-panel"
                >
                  <p>{user.survey}</p>
                </Panel>
              );
            })} */}
        </Collapse>
      </Card>
    </div>
  );
}
